import { initFbPixel } from '@app/libs/facebook_pixel/fbpixel'


const initThirdParties = () => {
    const appMode = import.meta.env.VITE_APP_MODE
    const isProduction = appMode === 'production'

    if (isProduction) {
        initFbPixel()
    }
}

export default initThirdParties
